import React from 'react';
import TextField from '@material-ui/core/TextField';
import {isEmpty,isUndefined} from 'lodash'
import IntlMessages from 'util/IntlMessages';
import { injectIntl } from 'react-intl';

function Syfte(props) {
    const Synclabel = props.intl.formatMessage({ id: 'Label.Sync.outlook' });
    const [Value,setValue] = React.useState(props.Syfte)
    const onchangeHandle=(e)=>{
        setValue(e.target.value)
    }
    const onBlurHandle=()=>{
        props.onchangeHanelEvent("Syfte",Value)
    }
    React.useEffect(()=>{
        setValue(props.Syfte)
    },[props.Syfte])
    console.log(props.Syfte,"props.Syfte")
    return (
        <div>
          <TextField
           fullWidth
           defaultValue=""
           placeholder={isUndefined(props.HasOutlook)?"":parseInt(props.HasOutlook)=== 1?Synclabel:""}
           disabled={isUndefined(props.disAbeld)?false:props.disAbeld}
           error={isEmpty(Value)}
           variant="outlined"
           size="small"
           name="title"
           label={<IntlMessages id="Input.Purpose"/>}
           InputLabelProps={{ shrink: true }}
           value={Value}
           onChange={onchangeHandle}
           onBlur={onBlurHandle}
           />
        </div>
    );
}

export default injectIntl(Syfte);